<div class="_content flex flex-column flex-justify-end">
    <div #content>
        <ng-content></ng-content>
    </div>
</div>